import React, { useEffect, useState } from 'react';
import { Container, Form, Header, Icon, Breadcrumb, Button, Grid, Placeholder, Segment, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useHistory, useLocation, useParams } from 'react-router';
import { useEmployerPartnerForm, EmployerPartnerData } from './useEmployerPartnerForm';
import moment from 'moment';

export type EditEmployerPartnerFormProps = {
    data: EmployerPartnerData,
    closePopup: Function,
}

export const EditEmployerPartnerForm: React.FC<EditEmployerPartnerFormProps> = ({ data, closePopup }) => {
    let [values, masterData, errors, touched, isLoading, isSubmitting, isValid, submitSuccess, errorMessage, registerRef, handleChange, handleBlur, handleSubmit, handleDelete] = useEmployerPartnerForm(data, closePopup);
    const history = useHistory();

    function handleBackToList() {
        // should close the popup
        closePopup();
    }

    return <div>
        <Grid columns={1} style={submitSuccess ? { margin: 0 } : {}}>
            {
                !submitSuccess &&
                <>
                    <Grid.Column>
                        <Form loading={isSubmitting}>
                            <Form.Input className={!(!errors.name || !touched.name) ? 'mb-0' : ''}
                                required
                                fluid
                                label='Name'
                                value = {values.name}
                                onChange={(event, data) => {
                                    handleChange(data.value, 'name');
                                }}
                                onBlur={
                                    () => { handleBlur('name') }
                                }
                                error={!(!errors.name || !touched.name) ? true : false}
                            />
                            {
                                !(!errors.name || !touched.name) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.name}</div>
                            }
                            <Form.Input className={!(!errors.website || !touched.website) ? 'mb-0' : ''}
                                required
                                fluid
                                label='Website'
                                value={values.website}
                                onChange={(event, data) => {
                                    handleChange(data.value, 'website');
                                }}
                                onBlur={
                                    () => { handleBlur('website') }
                                }
                                error={!(!errors.website || !touched.website) ? true : false}
                            />
                            {
                                !(!errors.website || !touched.website) &&
                                <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.website}</div>
                            }
                            <Button type='button' loading={isSubmitting} primary onClick={handleSubmit}>Submit</Button>
                            {
                                data.employerPartnerId > 0 &&
                                <Button type='button' onClick={() => { handleDelete() }} color='red'>Delete</Button>    
                            }
                            <Button type='button' onClick={() => { handleBackToList() }}>Cancel</Button>
                        </Form>
                    </Grid.Column>
                </>
            }
        </Grid>
    </div>
}